import { connect } from 'react-redux';

import SupportComponent from '../components/profile/Support/SupportComponent';
import { generateZendeskToken } from '../store/actions/session';
import { getLoadingStatus, filterLicenses } from './selectors/licenseSelectors';
import { getAllCompanies, getCurrentCompanyId } from './selectors/companySelectors';

const mapStateToProps = (state, { history, location: { state: locationState = {} }, isDev }) => ({
    isLoading: getLoadingStatus(state),
    licenses: filterLicenses(state),
    companies: getAllCompanies(state),
    currentCompanyId: getCurrentCompanyId(state),
    isDev,
    history,
    locationState,
});
const mapDispatchToProps = {
    generateZendeskToken,
}

const mergeProps = (
    { ...stateProps },
    { generateZendeskToken },
) => ({
    ...stateProps,
    genToken: generateZendeskToken,
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(SupportComponent);



// WEBPACK FOOTER //
// ./src/containers/SupportContainer.js